import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { toTimezone } from 'utils/dateTimeUtils';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Icon, Tooltip } from 'antd';
import Table from './table';
import styles from '../index.less';

const cx = classNames.bind(styles);
const defaultProps = {};
const propTypes = {
  slotDetail: PropTypes.object.isRequired,
  fieldsInfo: PropTypes.array.isRequired,
};

class Card extends React.Component {
  handleSyncClick = (slotId) => {
    const { refreshSlot } = this.props;
    refreshSlot(slotId);
  };

  checkRestrictedFields = () => {
    const { slotDetail, fieldsInfo } = this.props;
    if (_.has(slotDetail.related_meta, 'count')) return false;

    return fieldsInfo.some((field) =>
      field &&
        field.restriction &&
        Object.keys(slotDetail.related_meta).some((meta) => field.id === slotDetail.related_meta[meta].id));
  };

  renderFooter = () => {
    const { slotDetail, activeDashboard } = this.props;
    const {
      bind_data_source, dashboard_id, report_id, adopt_report
    } = slotDetail;
    const {
      last_refresh_refresh_result,
      last_refresh_refresh_msg,
      last_success_refresh_datetime,
      last_success_refresh_data_count,
    } = bind_data_source;

    switch (true) {
      case _.toNumber(activeDashboard) === dashboard_id &&
        _.has(bind_data_source, 'errors'):
        const { errors } = bind_data_source;
        return (
          <span className={cx('error-msg')}>
            {errors && (
              <FormattedMessage id="page.dashboard.errors.slotError" />
            )}
          </span>
        );

      case last_refresh_refresh_result !== 'success':
        return (
          <span className={cx('error-msg')}>{last_refresh_refresh_msg}</span>
        );

      default:
        return (
          <React.Fragment>
            <FormattedMessage
              id="page.dashboard.lastUpdate"
              defaultMessage="Last Updated"
              tagName="span"
            />
            &nbsp;
            {bind_data_source && !_.isEmpty(last_success_refresh_datetime)
              ? toTimezone(last_success_refresh_datetime, true)
              : ''}
            <br />
            {last_success_refresh_data_count > 12 ?
              <div className={cx('data-limit-message')}>
                <FormattedMessage
                  id="page.dashboard.sourceReportMessage.upto12rows"
                  tagName="span"
                />
                <Link
                  to={`/reports/report-setup/${adopt_report.type}/${report_id}`}
                  target="_blank"
                  className={cx('underline-link')}
                >
                  <FormattedMessage
                    className={cx('card-underline')}
                    id="page.dashboard.sourceReportMessage.sourceReportLink"
                  />
                </Link>
                <FormattedMessage
                  id="page.dashboard.sourceReportMessage.checkMoreData"
                  tagName="span"
                />
              </div> : ''}
          </React.Fragment>
        );
    }
  };

  renderAction = () => {
    const { slotDetail } = this.props;
    const hasRestrictedFields = this.checkRestrictedFields();

    if (hasRestrictedFields) {
      return (
        <Icon
          type="warning"
          className={classNames(cx('card-header-sync'), cx('card-warning'))}
        />
      );
    }
    return slotDetail.is_refreshing ? (
      <span className={cx('card-header-text')}>
        <FormattedMessage
          id="page.dashboard.updating"
          defaultMessage="Updating"
        />
        ...
      </span>
    ) : (
      <Tooltip
        title={
          <FormattedMessage
            id="page.dashboard.updateThisReport"
            defaultMessage="Update This Report"
          />
        }
      >
        <Icon
          type="sync"
          className={classNames(cx('card-header-sync'), 'cursor-pointer')}
          onClick={() => this.handleSyncClick(slotDetail.id)}
        />
      </Tooltip>
    );
  };

  render() {
    const { slotDetail } = this.props;
    const { bind_data_source } = slotDetail;

    return (
      <div className={cx('report-list-card')} id={slotDetail.id}>
        <div className={cx('card-header')}>
          <span className={cx('card-header-title')}>{slotDetail.name}</span>
          {this.renderAction()}
        </div>
        <div className={cx('card-table-container')}>
          <Table slotDetail={slotDetail} />
        </div>
        <div className={cx('card-footer')}>
          {bind_data_source && this.renderFooter()}
        </div>
      </div>
    );
  }
}

Card.defaultProps = defaultProps;
Card.propTypes = propTypes;

export default Card;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/rightSection/card/card.jsx